const OrderOrigin = () => import('./OrderOrigin')

export default function install(Vue) {
  Vue.component('OrderOrigin', OrderOrigin)
}
